import React from 'react';
import ReactPlayer from 'react-player';
import Modal from '../themed/modal';

interface VideoPlayerProps {
	sourceUrl: string;
	onCloseVideo: () => void;
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({
	onCloseVideo,
	sourceUrl,
}) => {
	if (!sourceUrl) return null;

	return (
		<Modal isVisible onClose={onCloseVideo}>
			<ReactPlayer
				url={sourceUrl}
				width="100%"
				height="100%"
				muted={false}
				playing
				controls
			/>
		</Modal>
	);
};

export default VideoPlayer;
